module.exports = __webpack_public_path__ + "assets/images/animations/listarobinson-animation.png?ce154587";